

/* Estas funciones permiten agregar o remover a un parámetro del query string */
function addQueryParam(url, paramName, value) {
    url = removeQueryParam(url, paramName);
    if (url.indexOf('?') === -1)
        return url + "?" + paramName + "=" + value;
    else
        return url + "&" + paramName + "=" + value;
}

function removeQueryParam(url) {
    var regex = new RegExp("(?:\\?|&)ver=\\d+$|(\\?|&)ver=\\d+&", "i");
    return url.replace(regex, '$1');
}

// Esta función genera un objeto con el query string
function parseQuery(qstr) {
    var query = {};
    var a = qstr.split('&');
    for (var i in a) {
        if (a.hasOwnProperty(i)) {
            var b = a[i].split('=');
            query[decodeURIComponent(b[0])] = decodeURIComponent(b[1]);
        }
    }

    return query;
}

